export class FAQ {
    Name:string;
    Email:string;
    PhoneNo:string;
    Subject:string;
    Message:string;
    Captcha:string='';
}
